import React from 'react';
import { ResponderNamesWrapper } from '@atlassian/eoc-responder-names';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { FieldLoader } from '@atlassian/jira-issue-create-commons/src/common/ui/field-loader/index.tsx';
import { FieldContainer } from '@atlassian/jira-issue-create-commons/src/common/ui/fields/styled.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { AsyncLinkedAlertsField } from './async.tsx';
import type { Props } from './ui/index.tsx';

export const LinkedAlertsField = (props: Props): React.JSX.Element => (
	<ErrorBoundary id="issue.fields.linked-alerts" packageName="AsyncLinkedAlertsField">
		<ResponderNamesWrapper>
			<FieldContainer data-testid="issue-field-linked-alerts.field-container" width="100%">
				<Placeholder name="linked-alerts-field" fallback={<FieldLoader />}>
					<AsyncLinkedAlertsField {...props} />
				</Placeholder>
			</FieldContainer>
		</ResponderNamesWrapper>
	</ErrorBoundary>
);
